import FirstServicesIcons from "../../assets/svg/FirstServiceIcon.svg";
import SecondServicesIcons from "../../assets/svg/SecondServiceIcon.svg";
import SearchIcon from "../../assets/svg/SearchIcon.svg";
import TransferIcon1 from "../../assets/svg/TranseferIcon1.svg";
import InfoItem from "../InfoItem";
import { useEffect, useState } from "react";
import axios from "axios";
import "./OrderDetailsCard.css";
import {
  GET_ALL_VEHICLE_ORDERS,
  GET_ORDERS_DATA_TO_ASSIGN_TO_VEHICLE,
} from "../../URLs/Apis";
import noDataFound from "../../assets/images/noDataFound.jpg";
import { Modal } from "react-bootstrap";
import ArrDown from "../../assets/svg/ArrDown.svg";

// Note that
import Processing from "../../assets/svg/Processingsvg.svg";
import Completed from "../../assets/svg/Completed.svg";
import Executing from "../../assets/svg/Executing.svg";
import Executed from "../../assets/svg/Executed.svg";
import Canceled from "../../assets/svg/Canceled.svg";
import Postponed from "../../assets/svg/Postponed.svg";
import Helprequest from "../../assets/svg/Helprequest.svg";
import Confirmed from "../../assets/svg/Confirmed.svg";

import { Checkbox, TextField } from "@mui/material";
import CarWosh from "../../assets/svg/CarWosh.icon.svg";
import batary from "../../assets/svg/batary.svg";
import Caver from "../../assets/svg/Caver.icon.svg";
import galon from "../../assets/svg/galon.Icon.svg";
import dateFormat from "dateformat";
import TransferOrders from "./TransferOrders";
import SelectTheVan from "./SelectTheVan";
import DeleteOrderFromVan from "./DeletOrderFromVan";
import Trash from "../../assets/svg/trash-bin.svg";
import { useSelector } from "react-redux";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { formatNumber } from "../../hooks/formatNumber";

const OrderDetailsCard = () => {
  const { user } = useSelector((state) => state.auth);
  //Select The Van
  const [showSelectTheVan, setShowSelectTheVan] = useState(false);

  //Transfer Orders
  const [slectedtransferOrders, setSlectedtransferOrders] = useState(null);
  const [transferOrders, setTransferOrders] = useState(false);
  const handleShowTransferOrders = () => {
    setTransferOrders(true);
  };

  //Van Profile
  const [vanProfileOrdersData, setvanProfileOrdersData] = useState([]);
  const [ordersErrorData, setordersErrorData] = useState(null);

  useEffect(() => {
    getVanProfileOrdersData();
  }, []);

  const getVanProfileOrdersData = () => {
    const headers = {
      Authorization: "Bearer " + user?.token,
    }; 
    axios
      .get(
        `${GET_ALL_VEHICLE_ORDERS}?vehicle_id=${window.location.href
          .split("/")
          .at(-1)}`,
        { headers }
      )
      .then((response) => {
        //data message success
        console.log("ordervan", response.data);
        setvanProfileOrdersData(response.data.data.order);
      })
      .catch((error) => {
        console.log(error.message);
        setordersErrorData(error.message);
      });
  };

  //Oerders REQUEST
  const [ordersDataToAssignToVehils, setOrdersDataToAssignToVehils] = useState(
    []
  );
  const getOrdersDataToAssignToVehils = () => {
    const headers = {
      Authorization: "Bearer " + user?.token,
    }; // auth header with bearer token

    axios
      .get(GET_ORDERS_DATA_TO_ASSIGN_TO_VEHICLE, { headers })
      .then((response) => {
        console.log("orders ", response.data.data.orders.data);
        setOrdersDataToAssignToVehils(response.data.data.orders.data);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  //Show the orders
  const [showAddOrder, setShowAddOrder] = useState(false);
  const handleCloseAddOrder = () => {
    setShowAddOrder(false);
  };
  const handleShowAddOrder = () => {
    setShowAddOrder(true);
    getOrdersDataToAssignToVehils();
  };

  //Show More Detals On orders
  const [TheOneToShowMore, setTheOneToShowMore] = useState(null);
  const ShowMoreDetalsOnOrder = (key) => {
    if (TheOneToShowMore) {
      return setTheOneToShowMore(null);
    }
    setTheOneToShowMore(key.toString());
  };
  const [TheOneToShowMore_main, setTheOneToShowMore_main] = useState(null);
  const ShowMoreDetalsOnOrder_main = (key) => {
    if (TheOneToShowMore_main === key) {
      setTheOneToShowMore_main(null);
      return;
    }
    setTheOneToShowMore_main(key);
  };

  //Filter the orders
  const [filterAddOrdersToVan, setFilterAddOrdersToVan] = useState({
    date: "",
    location: "",
  });

  //Select the orders
  const [checked_AddOrder, setChecked_AddOrder] = useState([]);
  const handleChange_AddOrder = (key) => {
    if (checked_AddOrder.filter((e) => e === key)[0]) {
      setChecked_AddOrder(checked_AddOrder.filter((e) => e !== key));
      return;
    }
    setChecked_AddOrder((prev) => [...prev, key]);
  };
  const [checkedAllOrders_AddOrder, setCheckedAllOrders_AddOrder] =
    useState(null);
  const handleCheckedAllOrders_AddOrder = (event) => {
    if (event.target.checked === false) {
      setCheckedAllOrders_AddOrder(false);
      setChecked_AddOrder([]);
      return;
    }
    setCheckedAllOrders_AddOrder(event.target.checked || true);
    setChecked_AddOrder(
      ordersDataToAssignToVehils.map((e) => (e.id ? e.id : null))
    );
  };

  //Sabmit the orders  /* note /*
  const SabmitAddingOrders = () => {
    const orders = ordersDataToAssignToVehils.filter((e) =>
      checked_AddOrder.includes(e.id)
    );
    setvanProfileOrdersData(orders);
    setShowAddOrder(false);
    console.log(orders);
  };

  //Delete the order from the vehicle
  const [showDeleteOrder, setShowDeleteOrder] = useState(false);
  const [deletOrderID, setDeletOrderID] = useState(null);

  const showDeleteOrderModol = (oerderID) => {
    setDeletOrderID(oerderID);
    setShowDeleteOrder(true);
  };

  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);

    const headers = {
      Authorization: "Bearer " + user?.token,
    }; // auth header with bearer token

    axios
      .get(
        `${GET_ALL_VEHICLE_ORDERS}?vehicle_id=${window.location.href
          .split("/")
          .at(-1)}&execution_date=${newDate?.format("YYYY-MM-DD") || null}`,
        { headers }
      )
      .then((response) => {
        console.log(response.data.data.orders);

        setvanProfileOrdersData(response.data.data.orders);
      })
      .catch((error) => {
        console.log(error.message);
        setordersErrorData(error.message);
      });
  };
  return (
    <>
      <DeleteOrderFromVan
        showDeleteOrder={showDeleteOrder}
        setShowDeleteOrder={setShowDeleteOrder}
        deletOrderID={deletOrderID}
        setTransferOrders={setTransferOrders}
        text={
          "Are you sure you want to remove this order from the vehicle? Confirm to proceed or cancel to keep it."
        }
      />
      <SelectTheVan
        showSelectTheVan={showSelectTheVan}
        setShowSelectTheVan={setShowSelectTheVan}
        slectedtransferOrders={slectedtransferOrders}
      />
      <TransferOrders
        transferOrders={transferOrders}
        setTransferOrders={setTransferOrders}
        vanProfileOrdersData={vanProfileOrdersData}
        setSlectedtransferOrders={setSlectedtransferOrders}
        setShowSelectTheVan={setShowSelectTheVan}
      />
      <Modal
        show={showAddOrder}
        fullscreen={"xl-down"}
        contentClassName="m-content"
        dialogClassName="m-dialog"
        onHide={handleCloseAddOrder}
      >
        <Modal.Header className="AddStaffModal_header">
          <Modal.Title className="AddStaffModal_title">Add Orders</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="serchAndFilter">
            <div className="serchAndFilter-serchBar">
              <input
                type="text"
                className="serchAndFilter-input"
                placeholder={`Search`}
                value={filterAddOrdersToVan.location}
                onChange={(e) => {
                  setFilterAddOrdersToVan({
                    ...filterAddOrdersToVan,
                    location: e.target.value,
                  });
                }}
              />
              <img src={SearchIcon} alt='' className="serchAndFilter-icon" />
            </div>
            <TextField
              label="Date"
              type="date"
              placeholder="DD/MM/YYYY"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              value={filterAddOrdersToVan.date}
              onChange={(e) => {
                setFilterAddOrdersToVan({
                  ...filterAddOrdersToVan,
                  date: e.target.value,
                });
              }}
            />
          </div>
          <table
            className="table  border "
            style={{
              width: "100%",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <thead className={`table-light table`}>
              <tr>
                <th className="headOfTable">
                  <Checkbox
                    className="p-0"
                    checked={checkedAllOrders_AddOrder}
                    onChange={(e) => handleCheckedAllOrders_AddOrder(e)}
                  />
                  <span className="ps-1">Order ID</span>
                </th>
                <th className="headOfTable">Client Name</th>
                <th className="headOfTable">Mobile N.</th>
                <th className="headOfTable">Service</th>
                <th className="headOfTable">Date</th>
                <th className="headOfTable">Time</th>
                <th className="headOfTable">Location</th>
                <th className="headOfTable">State</th>
                <th className="headOfTable">Action</th>
              </tr>
            </thead>
            <tbody>
              {ordersDataToAssignToVehils.map((e) => {
                return (
                  <>
                    <tr
                      style={{
                        backgroundColor: 1 % 2 === 0 ? "#ffffff" : "#f6f6f6",
                      }}
                    >
                      <td className=" bgInh-borderNone">
                        <Checkbox
                          className="p-0"
                          checked={
                            checked_AddOrder.filter((key) => key === e.id)[0]
                              ? true
                              : false
                          }
                          onClick={() => handleChange_AddOrder(e.id)}
                        />
                        <span className="textInBodyTable ps-1">#{e.id}</span>
                      </td>
                      <td className="centerXY bgInh-borderNone textInBodyTable">
                        {/* const blob = await res.blob();   */}
                        <img
                          src={async () => {
                            const blob = await e.user?.profile_photo.blob();
                            const url = URL.createObjectURL(blob);
                            return url;
                          }}
                          className="img-responsive-orders mainBorder"
                          alt=""
                        />
                        {e?.user?.name}
                      </td>
                      <td className=" bgInh-borderNone textInBodyTable">
                        {e?.user?.phone_number}
                      </td>
                      <td className=" bgInh-borderNone">
                        <div className=" d-flex align-items-center gap-2">
                          {/* <img
                            src={`https://estbn.com/MobileAppBackend/public${e.service_categories[0].icon_url}`}
                            alt="Service Icon"
                            style={{ width: "18px", height: "18px" }}
                          /> */}

                          <img
                            src={galon}
                            alt="Service Icon"
                            style={{ width: "18px", height: "18px" }}
                          />
                          <img
                            src={Caver}
                            alt="Service Icon"
                            style={{ width: "18px", height: "18px" }}
                          />
                          <img
                            src={batary}
                            alt="Service Icon"
                            style={{ width: "18px", height: "18px" }}
                          />
                          <img
                            src={CarWosh}
                            alt="Service Icon"
                            style={{ width: "18px", height: "18px" }}
                          />
                        </div>
                      </td>
                      <td className="textInBodyTable bgInh-borderNone">
                        {dateFormat(e.updated_at, "fullDate")}
                      </td>
                      <td className="textInBodyTable bgInh-borderNone">
                        {e.reservation
                          ? `${e.reservation.from} - ${e.reservation.to}`
                          : "Not Found"}
                      </td>
                      <td className="textInBodyTable bgInh-borderNone">
                        {e.address ? e.address.area : "Not Found"}
                      </td>
                      <td className="centerXY bgInh-borderNone">
                        <img
                          src={
                            e.status === "processing"
                              ? Processing
                              : e.status === "completed"
                                ? Completed
                                : e.status === "executing"
                                  ? Executing
                                  : e.status === "executed"
                                    ? Executed
                                    : e.status === "canceled"
                                      ? Canceled
                                      : e.status === "postponed"
                                        ? Postponed
                                        : e.status === "confirmed"
                                          ? Confirmed
                                          : Helprequest
                          }
                          alt="Expand Icon"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <p className="textInBodyTable">
                          {e?.status || "Processing"}
                        </p>
                      </td>
                      <td
                        onClick={() => ShowMoreDetalsOnOrder(e.id)}
                        className="bgInh-borderNone"
                      >
                        <img
                          src={ArrDown}
                          alt="Expand Icon"
                          style={{
                            width: "24px",
                            height: "24px",
                            cursor: "pointer",
                          }}
                          className={`${
                            TheOneToShowMore === e.id.toString()
                              ? "rotate180"
                              : ""
                          } transtion-movement`}
                        />
                      </td>
                    </tr>
                    <tr
                      style={{
                        backgroundColor: 1 % 2 === 0 ? "#ffffff" : "#f6f6f6",
                      }}
                      className={`moreDetalsOnOrder transtion-movement ${
                        TheOneToShowMore === e.id.toString() ? "" : "d-none"
                      }`}
                    >
                      <td className=" bgInh-borderNone">
                        <div className="titleOfMoreDetales">Source</div>
                        <div className="BodyOfMoreDetales">App</div>
                      </td>
                      <td className=" bgInh-borderNone textInBodyTable">
                        <div className="titleOfMoreDetales">Email</div>
                        <div className="BodyOfMoreDetales">
                          mahitabnabil@gmail.com
                        </div>
                      </td>
                      <td className=" bgInh-borderNone textInBodyTable">
                        <div className="titleOfMoreDetales">Order Date</div>
                        <div className="BodyOfMoreDetales">
                          {dateFormat(e.created_at, "fullDate")}
                        </div>
                      </td>
                      <td className="textInBodyTable bgInh-borderNone">
                        <div className="titleOfMoreDetales">Price</div>
                        <div className="BodyOfMoreDetales">
                          {formatNumber(e.total_price)} EGP
                        </div>
                      </td>
                      <td className=" bgInh-borderNone">
                        <div className="titleOfMoreDetales">Van ID</div>
                        <div className="BodyOfMoreDetales">Van {e.car_id}</div>
                      </td>
                      <td className="textInBodyTable bgInh-borderNone">
                        <div className="titleOfMoreDetales">Agent Name</div>
                        <div className="BodyOfMoreDetales">Ali Nassar</div>
                      </td>
                      <td className="textInBodyTable bgInh-borderNone">
                        <div className="titleOfMoreDetales">Stock</div>
                        <div className="BodyOfMoreDetales">Available</div>
                      </td>
                      <td className=" bgInh-borderNone">
                        <div className="titleOfMoreDetales">Car Modal</div>
                        <div className="BodyOfMoreDetales">{e?.car?.name}</div>
                      </td>
                      <td className="bgInh-borderNone"></td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
          <div className="OrdersTable-footer">
            <button onClick={SabmitAddingOrders} className="ordersSaveTable">
              Save
            </button>
            <button onClick={handleCloseAddOrder} className="ordersCancelTable">
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <div className="col-md-12">
        <div className="card py-3 px-2 my-3 mr-5  width-98">
          <div className="card-body p-2 sm:p-1 ">
            <div className="container d-flex align-items-center justify-content-between gap-5">
              <div className="input-group flex-nowrap position-relative justify-content-s rounded-2">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label="Select date"
                      value={selectedDate}
                      onChange={handleDateChange}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className=" container d-flex justify-content-end align-items-center ">
                <div className="row d-flex justify-content-between align-items-center gap-1 ">
                  <button
                    type="button"
                    onClick={handleShowTransferOrders}
                    className="align-items-center flex-nowrap justify-content-start bg-transparent border rounded-2 btn-xs buttons transfere-button"
                    // style={{ width: "auto", height: "48px" }}
                    disabled={!vanProfileOrdersData}
                  >
                    <img
                      src={TransferIcon1}
                      className={`${!vanProfileOrdersData ? "disabled" : ""}`}
                      alt="TransferIcon1"
                    />
                    Transfere Orders
                  </button>
                  <button
                    onClick={handleShowAddOrder}
                    type="button"
                    className=" align-items-center flex-nowrap justify-content-end bg-transparent border rounded-2 btn-xs buttons transfere-button"
                    // style={{ width: "116px", height: "48px" }}
                  >
                    + Add Order
                  </button>
                </div>
              </div>
            </div>
            <div
              className="accordion mt-5"
              id="accordionPanelsStayOpenExample "
            >
              {vanProfileOrdersData ? (
                vanProfileOrdersData.map((e) => {
                  return (
                    <>
                      <div className="accordion-item">
                        <h2 className="accordion-header " id={`${e.id}-head`}>
                          <button
                            onClick={() => ShowMoreDetalsOnOrder_main(e.id)}
                            className={`accordion-button  bg-light text-dark btn-xs buttons transfere-button`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${e.id}`}
                            aria-expanded="false"
                            aria-controls={`${e.id}`}
                          >
                            <div className="row justify-content-between w-100">
                              <div className="col-8">
                                Order
                                <span className="fw-bold g-1 text-dark m-2">
                                  #{e.id}
                                </span>
                              </div>
                              <div className="col-4 d-flex justify-content-end">
                                <span className="text-dark fw-bold">
                                {formatNumber(e.total_price)} EGP
                                </span>
                                <bottom
                                  type="button"
                                  onClick={() => showDeleteOrderModol(e.id)}
                                >
                                  <img
                                    src={Trash}
                                    className={`ps-2 pe-2`}
                                    alt="trash-bin"
                                  />
                                </bottom>
                              </div>
                            </div>
                          </button>
                        </h2>
                        <div
                          id={e.id}
                          className={`accordion-collapse collapse`}
                          aria-labelledby={`${e.id}-head`}
                        >
                          <div className="accordion-body">
                            <ul className="list-group list-group-flush">
                              <li className="list-group-item ">
                                <div className="row ">
                                  <li className=" fw-600 col-4">
                                    <div className=" mx-2">
                                      <InfoItem
                                        label="Date:"
                                        value={dateFormat(
                                          e.updated_at,
                                          "fullDate"
                                        )}
                                      />
                                      <InfoItem label="Payment:" value="Cash" />
                                    </div>
                                  </li>
                                  <li className="list-group-item fw-600 col-8 border-0">
                                    <div>
                                      <InfoItem
                                        label="Time:"
                                        value={
                                          e.reservation
                                            ? `${e.reservation.from} - ${e.reservation.to}`
                                            : "Not Found"
                                        }
                                      />
                                      <InfoItem
                                        label="Location:"
                                        style={{
                                          width: "min-width",
                                          overflow: "hidden",
                                        }}
                                        value={
                                          e.address
                                            ? `${e.address.address}`
                                            : "Not Found"
                                        }
                                      />
                                    </div>
                                  </li>
                                  <li className="list-group-item fw-600 col-6 border-0 mx-2">
                                    <div>
                                      <InfoItem
                                        label="Car Model:"
                                        value={e?.car?.name}
                                      />
                                    </div>
                                  </li>
                                </div>
                              </li>
                              <li className="list-group-item  ">
                                <h4 className="fs-5">
                                  <img src={FirstServicesIcons} alt='' />
                                  Oil Services
                                </h4>
                                <div>
                                  <div className="row">
                                    <h6
                                      style={{
                                        fontWeight: "400px",
                                        color: "#535353",
                                      }}
                                    >
                                      Check Oil
                                    </h6>
                                    <div className="row mt-3">
                                      <div className="col-md-10 col-sm-12 col-xs-12">
                                        <div className="in-block">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Oil Leack:
                                              </span>
                                              <span className="itemInfo">
                                                200 EGP
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="in-block ml-4">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Check Engine Oil:
                                              </span>
                                              <span className="itemInfo">
                                                100 EGP
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div className="col-md-2 col-sm-12 col-xs-12 text-right p-0 m-0">
                                        <h6 className="fw-bold">1000 EGP </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div className="row">
                                    <h6
                                      style={{
                                        fontWeight: "400px",
                                        color: "#535353",
                                      }}
                                    >
                                      Change Oil
                                    </h6>
                                    <div className="row mt-3">
                                      <div className="col-md-10 col-sm-12 col-xs-12">
                                        <div className="in-block">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Oil Brand:
                                              </span>
                                              <span className="itemInfo">
                                                Shell
                                              </span>
                                            </li>
                                          </ul>
                                        </div>

                                        <div className="in-block ml-4">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Oil Viscosity:
                                              </span>
                                              <span className="itemInfo">
                                                5W - 30
                                              </span>
                                            </li>
                                          </ul>
                                        </div>

                                        <div className="in-block ml-4">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Oil Liters:
                                              </span>
                                              <span className="itemInfo">
                                                5L
                                              </span>
                                            </li>
                                          </ul>
                                        </div>

                                        <div className="in-block ml-4">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Oil Filter:
                                              </span>
                                              <span className="itemInfo">
                                                Bosh
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>

                                      <div className="col-md-2 col-sm-12 col-xs-12 text-right p-0 m-0">
                                        <h6 className="fw-bold">1000 EGP </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li className="list-group-item ">
                                <h4 className="fs-5">
                                  <img src={SecondServicesIcons} alt=''/>
                                  Tire Services
                                </h4>
                                <div>
                                  <div className="row">
                                    <h6
                                      style={{
                                        fontWeight: "400px",
                                        color: "#535353",
                                      }}
                                    >
                                      Change Tire
                                    </h6>
                                    <div className="row mt-3">
                                      <div className="col-md-10 col-sm-12 col-xs-12">
                                        <div className="in-block">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Type:
                                              </span>
                                              <span className="itemInfo">
                                                Tubeless
                                              </span>
                                            </li>
                                          </ul>
                                        </div>

                                        <div className="in-block ml-4">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Brand:
                                              </span>
                                              <span className="itemInfo">
                                                Pirelli
                                              </span>
                                            </li>
                                          </ul>
                                        </div>

                                        <div className="in-block ml-4">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Made in:
                                              </span>
                                              <span className="itemInfo">
                                                5L
                                              </span>
                                            </li>
                                          </ul>
                                        </div>

                                        <div className="in-block ml-4">
                                          <ul className="p-0 m-0 in-block">
                                            <li>
                                              <span className="grayColor">
                                                Number of tires:
                                              </span>
                                              <span className="itemInfo">
                                                1 tire
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>

                                      <div className="col-md-2 col-sm-12 col-xs-12 text-right p-0 m-0">
                                        <h6 className="fw-bold">4000 EGP </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })
              ) : !ordersErrorData && !vanProfileOrdersData ? (
                <div className="noOrders-cards ">
                  <img
                    className="noOrdersImg"
                    src={noDataFound}
                    alt="No Orders Founde"
                  />
                  <p className="noDataOrders-masege">
                    No orders assigned to this van yet. Add orders to start
                    tracking.
                  </p>
                </div>
              ) : (
                <div className="noOrders-cards ">
                  <img
                    className="noOrdersImg"
                    src={noDataFound}
                    alt="No staff members"
                  />
                  <p className="noDataOrders-masege">{ordersErrorData}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default OrderDetailsCard;
